import { render, staticRenderFns } from "./create-locking.vue?vue&type=template&id=1c464d95&"
import script from "./create-locking.vue?vue&type=script&lang=ts&"
export * from "./create-locking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports